export default __webpack_public_path__ + "static/8-1cf302b4b28cdf08d3ef4fec7d11691c.jpg";